// axios
import axios from "axios";
import store from "./store/store";

const domain = "";
const api = axios.create({
  baseURL: domain,
  headers: {
    Accept: "application/json",
    "Content-type": "application/json",
  }
});

api.interceptors.request.use(
  (config) => {
    const JWT_TOKEN = store.getters.getToken;
    if (JWT_TOKEN) {
      config.headers.Authorization = `Bearer ${JWT_TOKEN}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
